import { useState, useRef, useEffect } from 'react';
import { css, cx } from '@eti/styles';
import { Icon } from '@eti/components';
import { Button, Text, textVariants, vars } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = css`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 100%;
  justify-content: center;
  padding: 10px 12px 9px;

  @media (min-width: 48em) {
    padding: 14px 14px 15px;
  }
`;
const iconTypeStyle = iconType => iconType === 'remove' ? css`
        fill: ${vars.colors.links.default};
        height: 12px;
        width: 12px;

        @media (min-width: 768px) {
          height: 14px;
          margin-top: 1px;
          width: 14px;
        }
      ` : css`
        fill: ${vars.colors.links.default};
        height: 14px;
        width: 14px;

        @media (min-width: 768px) {
          height: 16px;
          width: 16px;
        }
      `;
const labelStyles = css`
  font-size: 0.8125rem;
`;
const EditOrRemoveButton = _ref => {
  let {
    dataTestId,
    iconType,
    label,
    onClick
  } = _ref;
  const innerRef = useRef(null);
  const [isHighlighted, setIsHighlighted] = useState(false);
  const handleClick = () => {
    if (isHighlighted && onClick) {
      onClick();
    }
    setIsHighlighted(prev => !prev);
  };
  const handleClickOutside = event => {
    if (innerRef.current && !innerRef.current.contains(event.target)) {
      setIsHighlighted(false);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);
  return /*#__PURE__*/_jsxs(Button, {
    className: buttonStyles,
    "data-testid": dataTestId,
    onClick: handleClick,
    ref: innerRef,
    children: [isHighlighted && /*#__PURE__*/_jsx(Text, {
      className: labelStyles,
      variant: textVariants._14,
      children: label
    }), /*#__PURE__*/_jsx(Icon, {
      className: cx(iconTypeStyle(iconType)),
      id: iconType === 'remove' ? 'close' : 'edit'
    })]
  });
};
export default EditOrRemoveButton;
//# sourceMappingURL=EditOrRemoveButton.js.map